import { render, staticRenderFns } from "./setPayee.vue?vue&type=template&id=3a8d5792&scoped=true"
import script from "./setPayee.vue?vue&type=script&lang=js"
export * from "./setPayee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8d5792",
  null
  
)

export default component.exports